@if (currentPage()?.data?.length) {
  <div class="tile-component-container">
    @for (client of currentPage()!.data; track client) {
      <button class="tile" [routerLink]="client.detailsRouterLinkCommands">
        <div class="tile-detail">
          <div class="tile-icon">
            <svg-icon class="icon-container" [src]="client.icon.url" svgClass="icon" [svgAriaLabel]="client.type"></svg-icon>
          </div>
          <div class="tile-info">
            <p class="tile-title">{{client.name}}</p>
            <p class="tile-text">{{client.jurisdiction}}</p>
          </div>
        </div>
      </button>
    }
  </div>
}
